import { render, staticRenderFns } from "./LoadingLogo.vue?vue&type=template&id=8837ce0c&"
import script from "./LoadingLogo.vue?vue&type=script&lang=js&"
export * from "./LoadingLogo.vue?vue&type=script&lang=js&"
import style0 from "./LoadingLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports